import { render, staticRenderFns } from "./WcagReportModal.vue?vue&type=template&id=f5531262&scoped=true&"
import script from "./WcagReportModal.vue?vue&type=script&lang=js&"
export * from "./WcagReportModal.vue?vue&type=script&lang=js&"
import style0 from "./WcagReportModal.vue?vue&type=style&index=0&id=f5531262&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5531262",
  null
  
)

export default component.exports